export default __webpack_public_path__ + "static/media/simon.d7486a66.jpg";